import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';
import {styleMap} from 'lit-html/directives/style-map';

import TemplateRegistry from '../template/template-registry';
import {
    textValueSync, optionClassMap,
    optionDebounce, optionName, optionAutocomplete,
    textEditorCollapse, collapse
} from '../template/template-util.js';

TemplateRegistry.templates['text'] = (option, config, onChange) => html`
    <input type="text" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}" name="${optionName(option)}" .value=${live(option.value)} @input=${optionDebounce(option, (e) => textValueSync(e, option, onChange))}
      ?required=${option.required} minlength=${ifDefined(option.params.min)} maxlength=${ifDefined(option.params.max)} pattern=${ifDefined(option.params.pattern || undefined)} placeholder=${ifDefined(option.params.placeholder)} autocomplete="${optionAutocomplete(option)}" inputmode=${ifDefined(option.params.inputmode)} form=${ifDefined(config.productFormLink)} style=${styleMap({ textTransform: option.params.textTransform })}>

    ${option._editor ? (option._layer.params.collapse ?
       html`${collapse(textEditorCollapse(option),TemplateRegistry.templates['text_editor'](option, config, onChange), false,'cl-po--edit')}` 
     : html`${TemplateRegistry.templates['text_editor'](option, config, onChange)}`): null}
`;